module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/object/freeze.js